import { render, staticRenderFns } from "./defx.vue?vue&type=template&id=ce56183e&scoped=true"
import script from "./defx.vue?vue&type=script&lang=js"
export * from "./defx.vue?vue&type=script&lang=js"
import style0 from "./defx.vue?vue&type=style&index=0&id=ce56183e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce56183e",
  null
  
)

export default component.exports